/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let log: any;
declare let base: any;
declare let hall: any;
declare let WebDefine: any;
import { ModuleBase } from './ModuleBase'

export class WelcomeGiftModule extends ModuleBase {
  public welocmeInfo_: any = null
  public welcomeClickIndex = 0
  public isWelcome = false
  public isFirst = true

  init(): void {
    this.isFirst = true
  }

  onClear(): void {
    this.isFirst = true
  }

  onLoad(): void {}

  onDestroy(): void {
    this.welocmeInfo_ = null
    this.welcomeClickIndex = 0
    this.isWelcome = false
  }

  inits2c(): void {}

  onPreloadData(): void {
    log('WelcomeGiftModule onPreloadData')
    //this.getWelcomeList()
  }

  onClickGigtIndex(index: any) {
    this.welcomeClickIndex = index
  }

  onChengeIsWelcome(boolean: any) {
    this.isWelcome = boolean
  }

  getWelcomeInfo() {
    for (const key in this.welocmeInfo_) {
      if (Object.prototype.hasOwnProperty.call(this.welocmeInfo_, key)) {
        const num = this.welocmeInfo_[key].type - 1
        if (this.welcomeClickIndex == num) {
          return this.welocmeInfo_[key]
        }
      }
    }
    return null
  }

  //获取新人礼包总和奖励百分比
  getMaxReawrd() {
    let max = 0
    for (const key in this.welocmeInfo_) {
      if (Object.prototype.hasOwnProperty.call(this.welocmeInfo_, key)) {
        const reward =
          this.welocmeInfo_[key].diamond +
          this.welocmeInfo_[key].bonus +
          this.welocmeInfo_[key].gold
        max = max + reward
      }
    }
    return max
  }

  //展示当前要充值的挡位
  getNowBuystatus() {
    for (const key in this.welocmeInfo_) {
      if (Object.prototype.hasOwnProperty.call(this.welocmeInfo_, key)) {
        const num = this.welocmeInfo_[key].type - 1
        if (this.welocmeInfo_[key].status == 1) {
          if (num == 0) {
            return 0
          } else if (num == 1) {
            return 0.7
          } else {
            return 1
          }
        }
      }
    }
    return 0
  }

  //判断是否完成了新人礼包的三次充值
  isWelcomeEnd() {
    //if (this.welocmeInfo_ == null) {
    //    return false
    //}
    //let isRechargeNum = 0
    //for (const key in this.welocmeInfo_) {
    //    if (Object.prototype.hasOwnProperty.call(this.welocmeInfo_, key)) {
    //        if (this.welocmeInfo_[key].status == 3) {
    //            isRechargeNum += 1
    //        }
    //    }
    //}
    //return isRechargeNum == Object.keys(this.welocmeInfo_).length
    return true
  }

  //提供红点判断
  getRedstatus() {
    const red = [0, 0, 0]
    if (this.welocmeInfo_ == null) {
      return red
    }
    let index = 0
    for (const key in this.welocmeInfo_) {
      if (Object.prototype.hasOwnProperty.call(this.welocmeInfo_, key)) {
        red[index] = this.welocmeInfo_[key].status == 1 ? 1 : 0
        index++
      }
    }
    return red
  }

  //提供红点判断
  welcomeStatusRed() {
    const red = [0, 0, 0]
    if (this.welocmeInfo_ == null) {
      return red
    }
    let index = 0
    for (const key in this.welocmeInfo_) {
      if (Object.prototype.hasOwnProperty.call(this.welocmeInfo_, key)) {
        red[index] = this.welocmeInfo_[key].status == 3 ? 1 : 0
        index++
      }
    }
    return red
  }

  //获取新手礼包数据
  getWelcomeList() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.userWelcomeList, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.welocmeInfo_ = respJson.data
          if (this.isFirst) {
            this.isFirst = false
            hall.bindActivityModule.creatorRedStatus()
          }
          this.onChengeIsWelcome(false)
          hall.eventDispatcher.emit(hall.EventDefine.WelcomeList)
          hall.eventDispatcher.emit(hall.EventDefine.GoodsListChange)
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed)
        } else {
          log('getWelcomeList failFun')
        }
      })
      .catch((_error: any) => {
        log('error:', _error)
      })
  }
}
